"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPTChip = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const SPTType_1 = __importDefault(require("@opsbase/lib-spt/SPTType"));
const react_1 = __importDefault(require("react"));
const DataPill_1 = __importDefault(require("../DataPill"));
function SPTChip(props) {
    const { item, prefix } = props;
    if (!item || !item[`${prefix}SPTType`])
        return null;
    switch (item[`${prefix}SPTType`]) {
        case SPTType_1.default.STAFF: {
            const staff = item[`${prefix}Staff`];
            if (!staff)
                break;
            return (react_1.default.createElement(DataPill_1.default, { value: staff.title, type: DataType_1.default.STAFF, avatarUrl: staff.profileImageUrl }));
        }
        case SPTType_1.default.POSITION: {
            const position = item[`${prefix}Position`];
            if (!position)
                break;
            return react_1.default.createElement(DataPill_1.default, { value: position.title, type: DataType_1.default.POSITION });
        }
        case SPTType_1.default.TEAM: {
            const team = item[`${prefix}Team`];
            if (!team)
                break;
            return react_1.default.createElement(DataPill_1.default, { value: team.title, type: DataType_1.default.TEAM });
        }
    }
    return (react_1.default.createElement("div", { style: {
            minWidth: 26,
            minHeight: 26,
            display: 'flex',
            alignItems: 'center',
        } }, '- - -'));
}
exports.SPTChip = SPTChip;
exports.default = SPTChip;
